// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `a, li {
   cursor: pointer;
}
.text-textRequired{
    color : red;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/sign-off/sign-list/sign-list.component.css"],"names":[],"mappings":"AAAA;GACG,eAAe;AAClB;AACA;IACI,WAAW;AACf","sourcesContent":["a, li {\n   cursor: pointer;\n}\n.text-textRequired{\n    color : red;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
